'use client';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function getFormErrorMessages(errors: unknown): string[] {
  const messages = new Set<string>();
  const visited = new WeakSet<object>();
  const visit = (value: unknown) => {
    if (!value || typeof value !== 'object') return;
    if (visited.has(value)) return;
    visited.add(value);
    const entry = value as Record<string, unknown>;
    if (typeof entry.message === 'string' && entry.message.trim()) messages.add(entry.message);
    for (const [key, child] of Object.entries(entry)) {
      if (!['ref', 'message', 'type', 'types'].includes(key)) visit(child);
    }
  };
  visit(errors);
  return [...messages];
}

export function FormErrorSummary({ errors }: { errors: unknown }) {
  const { t } = useTranslations();
  const messages = getFormErrorMessages(errors);
  if (!messages.length) return null;
  return (
    <div role="alert" className="space-y-2 text-sm text-destructive">
      <p>{t('Skontrolujte vyplnené údaje. Formulár sa nepodarilo odoslať.')}</p>
      <ul className="list-disc pl-5">
        {messages.map(message => (
          <li key={message}>{message}</li>
        ))}
      </ul>
    </div>
  );
}
